import React, { ReactNode } from 'react'

export interface ISidebarIconWrapperLinkProps {
  href: string
  children: ReactNode | ReactNode
}

export const SidebarIconWrapperLink: React.FC<ISidebarIconWrapperLinkProps> = ({
  href,
  children,
}) => {
  return (
    <li key={href}>
      <a href={href} title={`Navigate to ${children}`}>
        {children}
      </a>
    </li>
  )
}
